export default __webpack_public_path__ + "static/media/social-medium.2cfa3e74.png";